// Core
import React from 'react';

// Hooks
import { useOverflowTooltip } from '../../hooks/useOverflowTooltip/useOverflowTooltip';

// Components
import {
  Paragraph,
  ParagraphSize,
  ParagraphWeight,
} from '../../layout/elements/Paragraph';
import { Tooltip } from '../../layout/elements/Tooltip';

// Component
import { HighlightCardProps } from './HighlightCard.types';
import {
  CardContent,
  Container,
  ContentContainer,
  Status,
  TextContainer,
  UnitContainer,
  ValueContainer,
} from './HighlightCard.style';

function HighlightCard({
  className,
  testId,
  text,
  status,
  value,
  unit,
}: HighlightCardProps): JSX.Element {
  // Hooks
  const {
    containerRef: contentContainerRef,
    isTooltipVisible: renderTooltip,
  } = useOverflowTooltip({
    overflowCheckTriggers: text,
  });

  const renderText: JSX.Element = (
    <TextContainer>
      {status && (
        <Status status={status} />
      )}
      <ContentContainer ref={contentContainerRef}>
        <Paragraph
          weight={ParagraphWeight.medium}
          size={ParagraphSize.sm}
          preventOverflow
        >
          {text}
        </Paragraph>
      </ContentContainer>
    </TextContainer>
  );

  return (
    <Container
      className={className}
      data-testid={testId}
      status={status}
    >
      <CardContent>
        {
          renderTooltip ? (
            <Tooltip text={text}>
              {renderText}
            </Tooltip>
          )
            : renderText
        }
        <ValueContainer unit={unit}>
          <Paragraph
            weight={ParagraphWeight.bold}
            size={ParagraphSize.sm}
          >
            {value}
          </Paragraph>
          <UnitContainer>
            <Paragraph
              weight={ParagraphWeight.bold}
              size={ParagraphSize.xs}
            >
              {unit}
            </Paragraph>
          </UnitContainer>
        </ValueContainer>
      </CardContent>
    </Container>
  );
}

export { HighlightCard };
